import React, { useEffect, useState, useContext, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UserContext } from "../common/UserContext";
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import { FaPlus, FaCog, FaTags, FaEdit, FaTrash, FaPencilAlt, FaTimes } from "react-icons/fa";
import { Button, InputGroup, Modal, Form } from 'react-bootstrap';
import Icon3 from "../../assest/images/Icon3.png";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import config from "../../envconfig";

function EmailEdit() {
    const [emailModal, setEmailModal] = useState(false);
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        EMTPL_Subject: '',
    });
    const [errMsg, setErrMsg] = useState({});
    const [emailModalkeyword, setEmailModalkeyword] = useState(false);
    const [setting, setSetting] = useState({});
    const [selectedfromScpName, setSelectedfromScpName] = useState('');
    const [selectedTransmissionValue, setselectedTransmissionValue] = useState('');
    const [selectedTransmissionID, setselectedTransmissionID] = useState('');
    const [selectedtoScpName, setSelectedtoScpName] = useState('');
    const [selectedemailsubject, setSelectedemailsubject] = useState('');
    const [selectedemailbody, setSelectedemailbody] = useState('');
    const [selectedtoemaillist, setSelectedtoemaillist] = useState('');
    const [, setselectedfromScpLevelNo] = useState('');
    const [emailEventValue, setEmailEventValue] = useState('');
    const [selectedShipmentType, setSelectedShipmentType] = useState('');
    const [emailKeywordsData, setEmailKeywordsData] = useState([]);
    const [emailStatus, setEmailStatus] = useState(null);
    const [showAsterisks, setShowAsterisks] = useState({});
    const [loading, setLoading] = useState(false);
    const [selectedoldemailsubject, setSelectedoldemailsubject] = useState('');
    const [selectedoldemailbody, setSelectedoldemailbody] = useState('');
    const [selectedoldtoemaillist, setSelectedoldtoemaillist] = useState('');
    const [oldemailStatus, setoldEmailStatus] = useState(null);
    const [isSelectOpen, setIsSelectOpen] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [newlyAddedUsers, setNewlyAddedUsers] = useState([]);
    const [newUserContact, setNewUserContact] = useState("");
    const [userCount, setUserCount] = useState(0);
    const [scpOptions, setScpOptions] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [modalTempList, setModalTempList] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [showInputAsterisk, setShowInputAsterisk] = useState(false);
    const [templateDetails, setTemplateDetails] = useState([]);

    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const { id } = useParams();
    const [selectedCountry, setSelectedCountry] = useState('in');
    const allowedCountries = ['in', 'af', 'dz', 'au', 'at', 'be', 'us'];

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [editingUser, setEditingUser] = useState(null);
    const [selectedDialCode, setSelectedDialCode] = useState("91");
    const phoneLengthMapping = {
        "91": 10,
        "93": 9,
        "213": 9,
        "61": 9,
        "43": 10,
        "32": 9,
        "1": 10,
    };
    // Remove shouldCloseModalAfterUpdate state since we want explicit control
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    const toastRef = useRef(null);
    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };

    useEffect(() => {
        const fetchTemplateData = async () => {
            try {
                const response = await fetch(`${config.API_URL}/getEditTemplate/${id}`);

                if (!response.ok) {
                    logAction(`API Execution Failed :  /getEditTemplate/${id}`);
                    throw new Error('Failed to fetch template data');
                }

                const data = await response.json();
                console.log("Template data:", data);

                if (data.success && data.emailData.length > 0) {
                    const emailData = data.emailData[0];
                    logAction(`Fetched email data: ${JSON.stringify(emailData)}`);

                    setSelectedfromScpName(emailData.FromSCPM_Name);
                    setSelectedtoScpName(emailData.ToSCPM_Name);
                    setSelectedemailsubject(emailData.EMTPL_Subject);
                    setSelectedemailbody(emailData.EMTPL_Body);
                    setSelectedShipmentType(emailData.EMTPL_SHPTTYPE);
                    setEmailEventValue(emailData.EMTPL_EmailEventId);
                    setSelectedoldemailsubject(emailData.EMTPL_Subject);
                    setSelectedoldemailbody(emailData.EMTPL_Body);
                    setselectedTransmissionValue(emailData.TransmissionMode);
                    setselectedTransmissionID(emailData.EMTPL_TransmissionID);

                    if (emailData.EnumVal === 0) {
                        setEmailStatus(0);
                        setoldEmailStatus('Active');
                        logAction(`Email status set to Active`);
                    }
                    else if (emailData.EnumVal === 1) {
                        setEmailStatus(1);
                        setoldEmailStatus('Inactive');
                        logAction(`Email status set to Inactive`);
                    }
                    else {
                        throw new Error('Invalid EnumVal value');
                    }

                    // Extract template details from API response
                    if (emailData.EMPTL_TemplateDetails && Array.isArray(emailData.EMPTL_TemplateDetails)) {
                        setTemplateDetails(emailData.EMPTL_TemplateDetails);
                        console.log("Loaded template details:", emailData.EMPTL_TemplateDetails);
                    }

                    // Fetch user list
                    const payload = {
                        EMTPL_EmailTemplateId: id,
                        CompanyID: UM_CompanyID,
                        SCP_ID: emailData.EMTPL_TOSCPID
                    };

                    logAction(`Calling secondary API /editusers with payload: ${JSON.stringify(payload)}`);

                    const response2 = await fetch(`${config.API_URL}/editusers`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload),
                    });

                    if (!response2.ok) {
                        logAction(`Secondary API failed /editusers with payload: ${JSON.stringify(payload)}`);
                        throw new Error('Failed to fetch user list');
                    }

                    const usersData = await response2.json();
                    logAction(`User list fetched: ${JSON.stringify(usersData)}`);

                    if (usersData.success) {
                        console.log("User data:", usersData.data);
                        const userOptions = usersData.data.map((u, index) => ({
                            value: u.UM_UserId || u.value || `user-${u.EMPTLD_ID || index}`,
                            label: u.UM_UserCode || u.label || `Added User-${index + 1}`,
                            email: u.UM_EmailAddress || u.email,
                            phone: u.UM_PhoneNumber || u.phone,
                            checked: u.checked === 1 || u.checked,
                            flag: u.flag || 0,
                            isChecked: u.isChecked || (u.checked === 1),
                            detailData: u.EMPTLD_DetailData || u.detailData ||
                                (selectedTransmissionID === 2 ? (u.UM_PhoneNumber || u.phone) : (u.UM_EmailAddress || u.email)),
                            EMPTLD_ID: u.EMPTLD_ID || index,
                            EMPTLD_TemplateId: u.EMPTLD_TemplateId,
                            isNew: false,
                            originalId: u.UM_UserId || u.value
                        }));
                        setScpOptions(userOptions);

                        const preselected = userOptions.filter(u => u.checked).map(u => u.value);
                        setSelectedUsers(preselected);

                        // Update template details from user data
                        const templateUsers = userOptions.filter(u => u.flag === 1);
                        if (templateUsers.length > 0) {
                            const formattedTemplateDetails = templateUsers.map(u => ({
                                data: u.detailData,
                                isChecked: u.isChecked || false
                            }));
                            setTemplateDetails(formattedTemplateDetails);
                        }
                    }

                } else {
                    throw new Error('No data found in API response');
                }
            } catch (err) {
                console.error('Error fetching template data:', err);
                logAction(`Error fetching template data: ${err.message}`);
                showToast('error', 'Failed to load template data');
            }
        };

        fetchTemplateData();
    }, [id]);

    useEffect(() => {
        logAction(`Executing API: /fetchScpDetails/ with parameters: ${selectedScpId}`);

        fetch(`${config.API_URL}/fetchScpDetails/${selectedScpId}`)
            .then(response => {
                logAction(`Received response with status: ${response.status}`);
                if (!response.ok) {
                    logAction(`API Execution Failed: /fetchScpDetails/ with parameters: ${selectedScpId}`);
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                logAction(`Response data: ${JSON.stringify(data)}`);

                if (data && data.SCPM_Name) {
                    setselectedfromScpLevelNo(data.SCPM_LevelNo);
                    logAction(`SCP Level No set to: ${data.SCPM_LevelNo}`);
                } else {
                    logAction(`No SCP Name found in response data`);
                }
            })
            .catch(error => {
                console.error('Error fetching SCP details:', error);
                logAction(`Error fetching SCP details: ${error.message}`);
            });
    }, [selectedScpId]);

    useEffect(() => {
        const fetchEventName = async () => {
            try {
                const response = await fetch(`${config.API_URL}/api/email/getEventName`);

                if (!response.ok) {
                    throw new Error('Failed to fetch event name');
                }
                const data = await response.json();

                if (data.success && (data.eventName === "Order" || data.eventName === "Shipment" || data.eventName === "Shipment Reason")) {
                    setEmailEventValue(data.eventName === "Order" ? "1" : "2");
                    logAction(`Email event value set to: ${data.eventName}`);
                } else {
                    logAction(`No valid event name found in API response`);
                    throw new Error('No data found in API response');
                }
            } catch (err) {
                logAction(`Error fetching event name: ${err.message}`);
                console.error('Error fetching event name:', err);
            }
        };
        fetchEventName();
    }, []);

    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "E-Mail Configuration", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const emailSetting = async () => {
        logAction('Opening email settings modal');
        setEmailModal(true);
        try {
            logAction(`Executing API: /api/email/setting`);
            const response = await fetch(`${config.API_URL}/api/email/setting`);
            logAction(`Received response with status: ${response.status}`);
            if (!response.ok) {
                logAction(`API Execution Failed : /api/email/setting`);
                throw new Error('Failed to fetch settings');
            }
            const data = await response.json();
            logAction(`Fetched settings data: ${JSON.stringify(data)}`);
            setSetting(data);
        } catch (err) {
            logAction(`Error fetching settings: ${err.message}`);
            console.error('Error fetching settings:', err);
        }
    };

    // const telegramEditorConfiguration = {
    //     toolbar: ['bold', 'italic', 'link', '|', 'undo', 'redo'],
    //     link: {
    //         addTargetToExternalLinks: true,
    //     },
    //     removePlugins: [
    //         'Heading',
    //         'List',
    //         'BlockQuote',
    //         'Indent',
    //         'Alignment',
    //         'Image',
    //         'Table',
    //         'MediaEmbed',
    //         'CKFinder',
    //     ],
    //     readOnly: false,
    // };

    const emailkeywords = async () => {
        logAction('Opening email keywords modal');
        setEmailModalkeyword(true);
        try {
            logAction(`Executing API: /api/email/keywords/ with parameters ${emailEventValue}`);
            const response = await fetch(`${config.API_URL}/api/email/keywords/${emailEventValue}`);
            logAction(`Received response with status: ${response.status}`);
            if (!response.ok) {
                logAction(`API Execution Failed : /api/email/keywords/ with parameters ${emailEventValue}`);
                throw new Error('Failed to fetch settings');
            }
            const data = await response.json();
            logAction(`Fetched email keywords data: ${JSON.stringify(data)}`);
            setEmailKeywordsData(data);
        } catch (err) {
            logAction(`Error fetching keywords: ${err.message}`);
            console.error('Error fetching settings:', err);
        }
    };

    const hideEmailSetting = () => {
        setEmailModal(false);
    };

    const hideEmailkeyword = () => {
        setEmailModalkeyword(false);
    };

    const handleEmailSubjectChange = (e) => {
        const { value } = e.target;
        setSelectedemailsubject(value);
        logAction(`Email subject changed to: ${value}`);
        if (value && showAsterisks.selectedemailsubject) {
            setShowAsterisks(prevAsterisks => ({
                ...prevAsterisks,
                selectedemailsubject: false
            }));
        }
    };


    const handleEmailBodyChange = (event, editor) => {
        const data = editor.getData();
        setSelectedemailbody(data);
        logAction(`Email body changed. Current content length: ${data.length}`);

        if (data && showAsterisks.selectedemailbody) {
            setShowAsterisks(prevAsterisks => ({
                ...prevAsterisks,
                selectedemailbody: false
            }));
        }
    };

    const handleShipmentTypeChange = (selectedOption) => {
        setSelectedShipmentType(selectedOption.value);
        logAction(`Shipment type changed to: ${selectedOption.label}`);
    };
    // const editorConfiguration = {
    //     toolbar: [
    //         'heading', '|',
    //         'bold', 'italic', '|',
    //         'bulletedList', 'numberedList', '|',
    //         'blockQuote', 'indent', '|',
    //         'undo', 'redo', '|',
    //         'selectall', '|',
    //     ],
    //     fontSize: {
    //         options: [9, 11, 13, "default", 17, 19, 21],
    //     },
    //     indentBlock: {
    //         offset: 20,
    //         unit: 'px',
    //     },
    // };

    const editorConfiguration = {

        toolbar: {
            items: [
                'heading',
                '|',
                'fontSize',
                'fontFamily',
                '|',
                'bold',
                'italic',
                'underline',
                'fontSize',
                'strikethrough',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'alignment',
                '|',
                'link',
                'blockQuote',
                '|',
                'undo',
                'redo'
            ]
        },

        list: {
            properties: {
                styles: true,
                startIndex: true,
                reversed: true
            }
        },
        fontSize: {
            options: [
                10,
                12,
                14,
                16,
                18,
                20,
                24,
                28,
                32
            ],
            supportAllValues: true
        },

        heading: {
            options: [
                { model: 'paragraph', title: 'Normal' },
                { model: 'heading3', view: 'h3', title: 'Large' },
                { model: 'heading2', view: 'h2', title: 'Extra Large' },
                { model: 'heading1', view: 'h1', title: 'Huge' }
            ]
        },

        htmlSupport: {
            allow: [{ name: /.*/, styles: true, classes: true, attributes: true }]
        },

        removePlugins: ['Title', 'Markdown']

    };
    const telegramEditorConfiguration = {
        toolbar: ['bold', 'italic', 'link', '|', 'undo', 'redo'],
        link: {
            addTargetToExternalLinks: true,
        },
        removePlugins: [
            'Heading',
            'List',
            'BlockQuote',
            'Indent',
            'Alignment',
            'Image',
            'Table',
            'MediaEmbed',
            'CKFinder', // ✅ Add this line
        ],
        readOnly: false,
    };
    const renderLabel = (field, label) => {
        return (
            <label className="label1">
                {label}
                {showAsterisks[field] && <span className="text-danger">*</span>}
            </label>
        );
    };

    const validateForm = () => {
        const asterisks = {};
        if (!selectedemailbody) {
            asterisks.selectedemailbody = true;
            logAction('Validation failed: Email body is empty');
        }

        if (selectedTransmissionID !== 2 && !selectedemailsubject) {
            asterisks.selectedemailsubject = true;
            logAction('Validation failed: Email subject is empty');
        }

        setShowAsterisks(asterisks);
        const isValid = Object.keys(asterisks).length === 0;
        logAction(`Form validation result: ${isValid ? 'Valid' : 'Invalid'}`);
        return isValid;
    };

    const resetForm = () => {
        // setFormData({
        //     EMTPL_Status: 0,
        // });
        setFormData({});
        setEmailStatus(0)
        setErrMsg({});
        setSelectedemailsubject('');
        setSelectedtoemaillist('');
        setSelectedemailbody('');
        setShowAsterisks({});
        setSelectedUsers([]);
        setNewlyAddedUsers([]);
        setModalTempList([]);
        setShowModal(false);
        setEditingId(null);
        setNewUserContact('');
        setTemplateDetails([]);
        logAction('Form has been reset');
        setTimeout(() => {
            setShowAsterisks(prevAsterisks => ({ ...prevAsterisks, selectedemailbody: false }));
        }, 50);
    };

    const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
        const auditLogPayload = {
            AUTR_ScreenName: module,
            AUTR_OldValue: oldValue,
            AUTR_NewValue: newValue,
            AUTR_Message: message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_AuditType: 15,
            AUTR_SCPID: selectedScpId,
            AUTR_CompanyGrpId: UM_CompanyGrpID,
            AUTR_CompanyID: UM_CompanyID,
            AUTR_CreatedBy: UM_UserId,
            insertAuditTransaction: true,
            transactionDetails
        };

        try {
            const response = await fetch(`${config.API_URL}/audit/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(auditLogPayload),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const isValid = validateForm();
        if (!isValid) {
            setLoading(false);
            return;
        }

        /* -------------------------------------------------------
           1. EXISTING USERS (flag === 0)
           - Only selected users are sent
        ------------------------------------------------------- */
        const existingUserIds = scpOptions
            .filter((u) => u.flag === 0 && selectedUsers.includes(u.value))
            .map((u) => u.value);

        /* -------------------------------------------------------
           2. TEMPLATE USERS (flag === 1)
           - NEVER remove user
           - Checkbox only updates EMPTLD_IsSelected
        ------------------------------------------------------- */
        const templateUsersWithCheckbox = scpOptions
            .filter((u) => u.flag === 1)
            .map((u) => {
                const isChecked = selectedUsers.includes(u.value);

                return {
                    data: selectedTransmissionID === 2 ? u.phone : u.email,
                    isChecked,
                    EMPTLD_IsSelected: isChecked ? 1 : 0
                };
            });

        /* -------------------------------------------------------
           3. NEWLY ADDED USERS
           - Always keep user
           - Checkbox controls EMPTLD_IsSelected
        ------------------------------------------------------- */
        const newTemplateUsersWithCheckbox = newlyAddedUsers.map((user) => {
            const isChecked = selectedUsers.includes(user.value);

            return {
                data: selectedTransmissionID === 2 ? user.phone : user.email,
                isChecked,
                EMPTLD_IsSelected: isChecked ? 1 : 0
            };
        });

        /* -------------------------------------------------------
           4. COMBINE ALL TEMPLATE USERS
        ------------------------------------------------------- */
        const allTemplateDetails = [
            ...templateUsersWithCheckbox,
            ...newTemplateUsersWithCheckbox
        ];

        /* -------------------------------------------------------
           5. REMOVE DUPLICATES (KEEP FIRST)
        ------------------------------------------------------- */
        const uniqueTemplateDetails = [];
        const seen = new Set();

        allTemplateDetails.forEach(detail => {
            if (!seen.has(detail.data)) {
                seen.add(detail.data);
                uniqueTemplateDetails.push(detail);
            }
        });

        console.log("📋 Final Template Details:", uniqueTemplateDetails);

        /* -------------------------------------------------------
           6. PREPARE FINAL PAYLOAD
        ------------------------------------------------------- */
        const now = new Date();
        const formattedNow = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;

        const updatedFormData = {
            ...formData,
            ETUL_UserID: existingUserIds,
            EMPTL_TemplateDetails: uniqueTemplateDetails,
            EMTPL_Subject: selectedemailsubject,
            EMTPL_Body: selectedemailbody,
            EMTPL_Status: emailStatus,
            EMTPL_ModifiedTimestamp: formattedNow,
            EMTPL_ModifiedBy: selectedScpId === "null" ? "Admin" : selectedScpId,
        };

        console.log("📦 Final Payload:", updatedFormData);

        /* -------------------------------------------------------
           7. API CALL
        ------------------------------------------------------- */
        const url = `${config.API_URL}/api/email/updateEmailTemplate/${id}`;

        fetch(url, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updatedFormData),
        })
            .then((res) => res.json())
            .then((data) => {
                console.log("Update response:", data);

                const toastMessage = getToastMessage(emailEventValue);
                showToast('success', toastMessage, {
                    onClose: () => {
                        setLoading(false);
                        navigate(`/dashboard/EmailConfiguration`);
                    },
                });

                logAction("Email template updated successfully");

                logAudit(
                    "Email Configuration",
                    "Email template updated successfully",
                    "",
                    JSON.stringify({
                        templateId: id,
                        subject: selectedemailsubject,
                        users: existingUserIds.length,
                        templateDetails: uniqueTemplateDetails.length
                    })
                );
            })
            .catch((err) => {
                console.error("Error updating email template:", err);
                setLoading(false);
                showToast('error', 'Failed to update template');
            });
    };

    const handleStatusChange = (e) => {
        const statusValue = e.target.value;
        const selectedOption = emailStatusOptions.find(opt => opt.id === statusValue);
        logAction(`Email status changed to: ${selectedOption?.name}`);
        setEmailStatus(statusValue);
    };

    const emailStatusOptions = [
        { id: 0, name: "Active" },
        { id: 1, name: "Inactive" }
    ];

    const getToastMessage = (eventId) => {
        const eventNames = {
            1: "Order Creation",
            2: `Shipment ${selectedShipmentType}`,
            3: `Shipment Return ${selectedShipmentType}`,
            4: "Scheme",
            6: "Order Updation"
        };

        const eventName = eventNames[eventId] || "Message Configuration";
        return `Message Configuration for Event Type : ${eventName} updated successfully.`;
    };

    const options = [
        { value: '1', label: 'Order Creation' },
        { value: '2', label: 'Shipment' },
        { value: '3', label: 'Shipment Return' },
        { value: '4', label: 'Scheme' },
        { value: '6', label: 'Order Updation' }, // Add this with appropriate label
    ];

    const options1 = selectedtoScpName
        ? [{ value: selectedtoScpName, label: selectedtoScpName }]
        : [{ value: '', label: '--Select--' }];

    const handleSCPListChange = (value) => {
        setSelectedUsers(prev => {
            if (prev.includes(value)) {
                return prev.filter(v => v !== value);
            } else {
                return [...prev, value];
            }
        });
    };

    // FIXED: Updated handleAddToTempList function
    const handleAddToTempList = () => {
        const trimmed = (newUserContact || "").trim();

        if (!trimmed) {
            setShowInputAsterisk(true);
            // showToast('error', `${selectedTransmissionID === 2 ? 'Phone number' : 'Email address'} is required.`);
            return;
        }

        let formattedValue = trimmed;

        // Validate and format based on transmission type
        if (parseInt(selectedTransmissionID) === 2) {
            const dialCode = selectedDialCode;
            const maxLength = phoneLengthMapping[dialCode] || 10;
            let digits = trimmed.replace(/\D/g, "");

            if (digits.startsWith(dialCode)) {
                digits = digits.slice(dialCode.length);
            }

            const local = digits.slice(0, maxLength);

            if (local.startsWith("0")) {
                showToast('error', "Phone number cannot start with 0.");
                return;
            }

            if (local.length !== maxLength) {
                showToast('error', `Phone number must be exactly ${maxLength} digits.`);
                return;
            }

            formattedValue = `+${dialCode} ${local}`;
        } else {
            formattedValue = trimmed.toLowerCase();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formattedValue)) {
                showToast('error', "Please enter a valid email address.");
                return;
            }
        }

        // ===============================================
        // FIX 1: EDIT MODE - Update existing template user
        // ===============================================
        if (editingId !== null && editingUser) {
            console.log("Editing user ID:", editingUser.EMPTLD_ID, "Value:", editingUser.detailData);

            // Check for duplicates (excluding self)
            const duplicateCheck = templateDetails.some((detail) => {
                // Skip the user being edited
                if (detail.EMPTLD_ID === editingUser.EMPTLD_ID) return false;
                return detail.data.toLowerCase() === formattedValue.toLowerCase();
            });

            if (duplicateCheck) {
                showToast('error',
                    parseInt(selectedTransmissionID) === 2
                        ? "Phone Number already exists."
                        : "Email Address already exists."
                );
                return;
            }

            // FIX 2: Add to modalTempList to show in table immediately
            const updatedTempItem = {
                id: editingId,
                display: formattedValue,
                raw: formattedValue,
            };

            // Check if already in modalTempList, update it
            const existsInTemp = modalTempList.find(item => item.id === editingId);
            if (existsInTemp) {
                setModalTempList(prev =>
                    prev.map(item =>
                        item.id === editingId ? updatedTempItem : item
                    )
                );
            } else {
                setModalTempList(prev => [...prev, updatedTempItem]);
            }

            // FIX 3: Don't update templateDetails/scpOptions here, just show success
            // The actual update will happen when SAVE button is clicked

            // Clear input but DON'T close modal
            if (selectedTransmissionID === 2) {
                setNewUserContact("+91");
                setSelectedDialCode("91");
                setSelectedCountry("in");
            } else {
                setNewUserContact("");
            }

            setShowInputAsterisk(false);

            // FIX 4: Show success message for update
            // showToast('success', 'User updated in list. Click SAVE to confirm.');

            // Reset editing state but keep modal open
            setIsUpdating(false);

            return;
        }

        // ===============================================
        // ADD MODE - Add to temporary list for modal
        // ===============================================
        const duplicateInTemp = scpOptions.some((u) => {
            if (parseInt(selectedTransmissionID) === 2) {
                return u.phone === formattedValue;
            } else {
                return u.email?.trim().toLowerCase() === formattedValue.trim().toLowerCase();
            }
        });

        if (duplicateInTemp) {
            showToast('error',
                parseInt(selectedTransmissionID) === 2
                    ? "Phone Number already exists."
                    : "Email Address already exists."
            );
            return;
        }

        const newTemp = {
            id: `temp-${Date.now()}`,
            display: formattedValue,
            raw: formattedValue,
        };

        setModalTempList((prev) => [...prev, newTemp]);

        // Clear input
        if (selectedTransmissionID === 2) {
            setNewUserContact("+91");
            setSelectedDialCode("91");
            setSelectedCountry("in");
        } else {
            setNewUserContact("");
        }

        setShowInputAsterisk(false);
        // showToast('success', 'User added to list. Click SAVE to confirm.');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddToTempList();
        }
    };

    const handleEditTemp = (id) => {
        const entry = modalTempList.find((item) => item.id === id);
        if (!entry) return;

        setEditingId(id);

        // Find the corresponding user in scpOptions or templateDetails
        const userInScpOptions = scpOptions.find(u =>
            u.EMPTLD_ID === id || u.value === id || u.detailData === entry.raw
        );

        if (userInScpOptions) {
            setEditingUser(userInScpOptions);
        }

        if (parseInt(selectedTransmissionID) === 2 && entry.raw) {
            const phoneWithoutPrefix = entry.raw.replace(/^\+\d+\s*/, '');
            setNewUserContact(phoneWithoutPrefix);

            const match = entry.raw.match(/^\+\d+/);
            if (match) {
                const dialCode = match[0].replace('+', '');
                setSelectedDialCode(dialCode);

                const country = allowedCountries.find(countryCode => {
                    return dialCode === "91" ? countryCode === "in" :
                        dialCode === "93" ? countryCode === "af" :
                            countryCode;
                });
                if (country) setSelectedCountry(country);
            }
        } else {
            setNewUserContact(entry.raw.toLowerCase());
        }

        setShowInputAsterisk(false);
    };

    const handleRemoveFromTemp = (id) => {
        setModalTempList((prev) => prev.filter((p) => p.id !== id));
        if (editingId === id) {
            setEditingId(null);
            setEditingUser(null);
            if (parseInt(selectedTransmissionID) === 2) {
                setNewUserContact("+91");
                setSelectedCountry("in");
            } else {
                setNewUserContact("");
            }
        }
    };

    // FIXED: Updated handleSaveFromModal function
    const handleSaveFromModal = () => {
        if (modalTempList.length === 0) {
            // setShowInputAsterisk(true);
            // showToast('error', 'You need to add at least one Email to save User Details.');
            showToast('error',
                parseInt(selectedTransmissionID) === 2
                    ? " At least one Contact is required to save the User Details."
                    : " At least one Email is required to save the User Details."
            );
            return;
        }

        // FIX 1: Handle editing existing users first
        if (editingId !== null && editingUser) {
            // Get the edited item from modalTempList
            const editedItem = modalTempList.find(item => item.id === editingId);
            if (!editedItem) {
                showToast('error', 'No data found for update.');
                return;
            }

            // Update scpOptions - REPLACE the existing user
            setScpOptions(prev => prev.map(user => {
                if (user.EMPTLD_ID === editingUser.EMPTLD_ID || user.value === editingUser.value) {
                    return {
                        ...user,
                        detailData: editedItem.raw,
                        email: selectedTransmissionID === 2 ? '' : editedItem.raw,
                        phone: selectedTransmissionID === 2 ? editedItem.raw : '',
                        label: user.label,
                        value: user.value,
                        EMPTLD_ID: user.EMPTLD_ID,
                        isNew: false
                    };
                }
                return user;
            }));

            // Update templateDetails - REPLACE the existing detail
            setTemplateDetails(prev => prev.map(detail => {
                if (detail.EMPTLD_ID === editingUser.EMPTLD_ID ||
                    (detail.data === editingUser.detailData && editingUser.detailData)) {
                    return {
                        ...detail,
                        data: editedItem.raw,
                        EMPTLD_DetailData: editedItem.raw,
                        EMPTLD_IsSelected: detail.EMPTLD_IsSelected || (detail.isChecked ? 1 : 0),
                        EMPTLD_ID: detail.EMPTLD_ID,
                        EMPTLD_TemplateId: detail.EMPTLD_TemplateId,
                        isChecked: detail.isChecked !== undefined ? detail.isChecked : true
                    };
                }
                return detail;
            }));

            // Update newlyAddedUsers if present
            setNewlyAddedUsers(prev => prev.map(user => {
                if (user.EMPTLD_ID === editingUser.EMPTLD_ID || user.value === editingUser.value) {
                    return {
                        ...user,
                        detailData: editedItem.raw,
                        email: selectedTransmissionID === 2 ? '' : editedItem.raw,
                        phone: selectedTransmissionID === 2 ? editedItem.raw : '',
                    };
                }
                return user;
            }));

            // Mark as selected
            if (!selectedUsers.includes(editingUser.value)) {
                setSelectedUsers(prev => [...prev, editingUser.value]);
            }

            // Clear modal and editing state
            setModalTempList([]);
            setNewUserContact('');
            setShowInputAsterisk(false);
            setShowModal(false);
            setEditingId(null);
            setEditingUser(null);

            showToast('success', 'Users added and selected successfully.');
            return;
        }

        // ===============================================
        // ADDING NEW USERS
        // ===============================================
        const existingTemplateUsers = scpOptions.filter(u => u.flag === 1);

        // Find the next number for Added User labels
        let nextLabelNumber = 1;
        existingTemplateUsers.forEach(user => {
            const match = user.label?.match(/Added User-(\d+)/);
            if (match) {
                const num = parseInt(match[1]);
                if (num >= nextLabelNumber) nextLabelNumber = num + 1;
            }
        });

        // Generate unique IDs for each new user
        const newUsers = modalTempList.map((item, index) => {
            const uniqueId = -(Date.now() + index);
            const labelNumber = nextLabelNumber + index;

            return {
                value: `temp-${uniqueId}`,
                label: `Added User-${labelNumber}`,
                phone: selectedTransmissionID === 2 ? item.raw : '',
                email: selectedTransmissionID === 2 ? '' : item.raw,
                checked: true,
                flag: 1,
                detailData: item.raw,
                isChecked: true,
                EMPTLD_ID: uniqueId,
                EMPTLD_TemplateId: id,
                isNew: true
            };
        });

        // Add to template details
        const newTemplateDetails = newUsers.map(user => ({
            EMPTLD_ID: user.EMPTLD_ID,
            EMPTLD_TemplateId: user.EMPTLD_TemplateId,
            data: user.detailData,
            isChecked: true,
            EMPTLD_IsSelected: 1,
            isNew: true
        }));

        // Update states
        setTemplateDetails(prev => [...prev, ...newTemplateDetails]);
        setScpOptions(prev => [...prev, ...newUsers]);
        setNewlyAddedUsers(prev => [...prev, ...newUsers]);

        // Mark as selected
        setSelectedUsers(prev => [
            ...new Set([...prev, ...newUsers.map(u => u.value)]),
        ]);

        // FIX 2: Clear modal and close it
        setModalTempList([]);
        setNewUserContact('');
        setShowInputAsterisk(false);
        setShowModal(false);
        setEditingId(null);
        setEditingUser(null);

        showToast('success', 'Users added and selected successfully.');
    };

    const handleDeleteUser = (user) => {
        setUserToDelete(user);
        setShowDeleteModal(true);
    };

    const confirmDeleteUser = () => {
        if (!userToDelete) return;

        const user = userToDelete;
        console.log("Deleting user:", user);

        // Remove from scpOptions only if it's a template user
        setScpOptions(prev => prev.filter(u => {
            // For template users, check EMPTLD_ID
            if (user.flag === 1 && user.EMPTLD_ID !== undefined) {
                return u.EMPTLD_ID !== user.EMPTLD_ID;
            }
            // For regular users, check value
            return u.value !== user.value;
        }));

        // Remove from selectedUsers
        setSelectedUsers(prev => prev.filter(id => id !== user.value));

        // Remove from newlyAddedUsers if present
        setNewlyAddedUsers(prev => prev.filter(u => {
            if (user.EMPTLD_ID !== undefined && u.EMPTLD_ID !== undefined) {
                return u.EMPTLD_ID !== user.EMPTLD_ID;
            }
            return u.value !== user.value;
        }));

        // Remove from templateDetails only if it's a template user
        if (user.flag === 1) {
            setTemplateDetails(prev =>
                prev.filter(detail => {
                    if (user.EMPTLD_ID !== undefined && detail.EMPTLD_ID !== undefined) {
                        return detail.EMPTLD_ID !== user.EMPTLD_ID;
                    }
                    // Fallback: compare by data
                    return detail.data !== user.detailData;
                })
            );
        }

        showToast('success', 'User deleted successfully.');
        setUserToDelete(null);
        setShowDeleteModal(false);
    };

    const handleEditUser = (user) => {
        if (!user) return;

        // For template users (flag === 1)
        if (user.flag === 1) {
            setEditingId(user.EMPTLD_ID || user.value);
            setEditingUser(user);

            // Clear modal temp list
            setModalTempList([]);

            // Pre-fill the input for editing
            if (selectedTransmissionID === 2) {
                // For phone
                if (user.detailData) {
                    const phoneWithoutPrefix = user.detailData.replace(/^\+\d+\s*/, '');
                    setNewUserContact(phoneWithoutPrefix);

                    // Extract country code
                    const match = user.detailData.match(/^\+\d+/);
                    if (match) {
                        const dialCode = match[0].replace('+', '');
                        setSelectedDialCode(dialCode);

                        const country = allowedCountries.find(countryCode => {
                            return dialCode === "91" ? countryCode === "in" :
                                dialCode === "93" ? countryCode === "af" :
                                    countryCode;
                        });
                        if (country) setSelectedCountry(country);
                    }
                } else {
                    setNewUserContact("");
                    setSelectedDialCode("91");
                    setSelectedCountry("in");
                }
            } else {
                // For email
                setNewUserContact(user.detailData || "");
            }

            // Open modal for editing
            setShowModal(true);
        } else {
            // For regular users (non-template), show message
            showToast('info', 'Regular users cannot be edited here.');
        }

        setShowInputAsterisk(false);
    };

    const handleCopyPlain = (e) => {
        e.preventDefault();
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const container = range.cloneContents();
        const keywordCells = container.querySelectorAll('td.keyword-cell');

        // Format the text as "keyword : description"
        let formattedText = '';

        // Assuming keyword cells alternate: keyword, description, keyword, description...
        for (let i = 0; i < keywordCells.length; i += 2) {
            const keyword = keywordCells[i]?.innerText?.trim() || '';
            const description = keywordCells[i + 1]?.innerText?.trim() || '';

            if (keyword && description) {
                formattedText += `${keyword} : ${description}\n`;
            }
        }

        // If no formatted text, fall back to original
        if (!formattedText.trim() && keywordCells.length > 0) {
            formattedText = Array.from(keywordCells).map(td => td.innerText).join('\n');
        }

        e.clipboardData.setData("text/plain", formattedText.trim());
    };

    // FIXED: Modal onHide handler
    const handleModalClose = () => {
        setShowModal(false);
        setModalTempList([]);
        if (parseInt(selectedTransmissionID) === 2) {
            setNewUserContact("+91");
            setSelectedCountry("in");
            setSelectedDialCode("91");
        } else {
            setNewUserContact("");
        }
        setShowInputAsterisk(false);
        setEditingId(null);
        setEditingUser(null);
        setIsUpdating(false);
    };


    // Helper function for dropdown open/close
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    return (
        <>
            {loading && (
                <div style={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1000
                }} />
            )}

            <div className='main_container'>
                <div className="orderHeader d-flex align-items-center justify-content-between">
                    <h1 className='formHeading' style={{marginLeft:'5px'}}>Message Configuration</h1>

                    {selectedTransmissionID === 1 && (
                        <div className="d-flex align-items-center gap-3">
                            <FaTags
                                size={22}
                                style={{ cursor: 'pointer' }}
                                title="Email Event Keywords"
                                onClick={emailkeywords}
                            />
                            <FaCog
                                size={22}
                                style={{ cursor: 'pointer' }}
                                title="Email Setting"
                                onClick={emailSetting}
                            />
                        </div>
                    )}
                </div>

                <div className="row" style={{ marginLeft: '-6px' }}>
                    <div className="col-md-3 mb-4">
                        {renderLabel('transmissionMode', 'Transmission Mode')}
                        {/* <div className="d-grid"> */}
                        <div className="select-container">
                            <input
                                id="transmissionMode"
                                readOnly
                                className="form-input"
                                value={selectedTransmissionValue}
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    color: '#6c757d',
                                }}
                            />
                            <div className="icon-container_list myList">
                                {/* <i> */}
                                {isSelectOpen === 'Transmission' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                {/* </i> */}
                            </div>
                        </div>
                        {/* </div> */}
                    </div>

                    <div className="col-md-3">
                        <label className="label1">Event Type</label>
                        <div className='select-container_list'>
                            <input
                                type="text"
                                id="scpName"
                                value={emailEventValue ? options.find(option => option.value === String(emailEventValue))?.label : ''}
                                readOnly
                                className="form-input"
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    color: '#6c757d',
                                }}
                            />
                            <div className="icon-container_list myList">
                                {isSelectOpen === "EMTPL_Type" ? (
                                    <IoCaretUpOutline />
                                ) : (
                                    <IoCaretDownOutline />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 mb-4">
                        <label htmlFor="scpName" className="label1">From </label>
                        <div className='select-container_list'>
                            <input
                                type="text"
                                id="scpName"
                                value={selectedfromScpName}
                                readOnly
                                className="form-input"
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    color: '#6c757d',
                                }}
                            />
                            <div className="icon-container_list myList">
                                {isSelectOpen === "EMTPL_From" ? (
                                    <IoCaretUpOutline />
                                ) : (
                                    <IoCaretDownOutline />
                                )}
                            </div>
                        </div>
                    </div>

                    {[1, 4, 6].includes(parseInt(emailEventValue)) && (
                        <div className="col-md-3 mb-4">
                            <label htmlFor="scpName" className="label1">To </label>
                            <strong style={{ display: 'none' }} id="tscp">*</strong>
                            <div className='select-container_list'>
                                {/* <Select
                                    id="scpNameDropdown"
                                    className="routing_select-box"
                                    value={options1[0]}
                                    isDisabled={true}
                                    options={options1}
                                    maxMenuHeight={150}
                                /> */}
                                <input
                                    type="text"
                                    id="scpName"
                                    value={selectedtoScpName}
                                    readOnly
                                    className="form-input"
                                    style={{
                                        backgroundColor: '#f2f2f2',
                                        color: '#6c757d',
                                    }}
                                />
                                <div className="icon-container_list myList">
                                    {isSelectOpen === "EMTPL_To" ? (
                                        <IoCaretUpOutline />
                                    ) : (
                                        <IoCaretDownOutline />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {(emailEventValue === 2 || emailEventValue === 3) && (
                        <div className="col-md-3">
                            <label htmlFor="shipmentType" className="">Shipment Type</label>
                            <div className='select-container_list'>
                                <Select
                                    className='routing_select-box'
                                    isDisabled={true}
                                    value={{ value: selectedShipmentType, label: selectedShipmentType }}
                                    onChange={handleShipmentTypeChange}
                                    options={[
                                        { value: '1', label: 'Shipment Outward' },
                                        { value: '2', label: 'Shipment Inward' },
                                        { value: '3', label: 'Shipment Return' }
                                    ]}
                                    maxMenuHeight={150}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            backgroundColor: '#f2f2f2',
                                            color: '#6c757d',
                                            // cursor: 'not-allowed',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            color: '#6c757d',
                                        }),
                                    }}

                                />
                                {/* <input
                                type="text"
                                id="scpName"
                                value={selectedShipmentType ? (selectedShipmentType === 1 ? 'Shipment Outward' : selectedShipmentType === 2 ? 'Shipment Inward' : selectedShipmentType === 3 ? 'Shipment Return' : '') : ''}
                                readOnly
                                className="form-input"
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    color: '#6c757d',
                                }}
                            /> */}
                                <div className="icon-container_list myList">
                                    {isSelectOpen === "EMTPL_Status" ? (
                                        <IoCaretUpOutline />
                                    ) : (
                                        <IoCaretDownOutline />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="d-flex col-md-3">
                        <Modal show={emailModalkeyword} onHide={hideEmailkeyword} backdrop="static"
                            centered keyboard={false}
                            style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)', color: "#465a64", }}>
                            <Modal.Header closeButton>
                                <Modal.Title style={{ fontSize: '20px', fontWeight: "bold" }}>
                                    Email Event Keywords
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="table-responsive">
                                    <table className="tableClass" onCopy={handleCopyPlain}>
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Event Keyword</th>
                                                <th>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {emailKeywordsData.map((keyword, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td style={{ userSelect: 'text' }} className="keyword-cell">{keyword.EMKW_TagName}</td>
                                                    <td style={{ userSelect: 'text' }} className="keyword-cell">{keyword.EMKW_FindValue}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Modal.Body>
                        </Modal>

                        {showDeleteModal && (
                            <div className="popup_overlay">
                                <div className="resetpopup">
                                    <h1>:: User Confirmation ::</h1>
                                    <h4>Are you sure you want to remove this record ?</h4>
                                    <div className="popup_btn_container">
                                        <button onClick={confirmDeleteUser} className="yes_btn">YES</button>
                                        <button onClick={() => {
                                            setShowDeleteModal(false);
                                            setUserToDelete(null);
                                        }} className="no_btn">NO</button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <Modal show={emailModal} onHide={hideEmailSetting} backdrop="static" centered
                            style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)', color: "#465a64", }}>
                            <Modal.Header closeButton>
                                <Modal.Title style={{ fontSize: '20px', fontWeight: "bold" }}>
                                    Email Setting
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="emailModal">
                                    <label>From Email</label>
                                    <input className="esett" type="text" value={setting.email} disabled={true} />
                                    <label>From Email Service</label>
                                    <input className="esett" type="text" value={setting.service} disabled={true} />
                                    <label>Port</label>
                                    <input className="esett" type="text" value={setting.port} disabled={true} />
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>

                <div className="row" style={{ marginLeft: '-6px' }}>
                    {parseInt(emailEventValue) === 2 && (
                        <div className="col-md-3 mb-4">
                            <label htmlFor="scpName" className="label1">To </label>
                            <strong style={{ display: 'none' }} id="tscp">*</strong>
                            <div className='select-container_list'>
                                {/* <Select
                                    id="scpNameDropdown"
                                    className="routing_select-box"
                                    value={options1[0]}
                                    isDisabled={true}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            cursor: 'pointer',
                                            borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
                                            boxShadow: state.isFocused ? 'none' : base.boxShadow,
                                            '&:hover': {
                                                borderColor: '#cfcfcf',
                                            },
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            marginTop: -1,
                                            zIndex: 9999,
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                        }),
                                    }}
                                    options={options1}
                                    maxMenuHeight={150}
                                /> */}
                                <input
                                    type="text"
                                    id="scpName"
                                    value={selectedtoScpName}
                                    readOnly
                                    className="form-input"
                                    style={{
                                        backgroundColor: '#f2f2f2',
                                        color: '#6c757d',
                                    }}
                                />
                                <div className="icon-container_list myList">
                                    {isSelectOpen === "scpName" ? (
                                        <IoCaretUpOutline />
                                    ) : (
                                        <IoCaretDownOutline />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* FIXED: Modal with correct behavior */}
                    <Modal
                        show={showModal}
                        onHide={handleModalClose}  // FIX 1: Use custom handler
                        centered
                        backdrop="static"
                        style={{ backdropFilter: "blur(3px)", backgroundColor: "rgba(0, 0, 0, 0.3)" }}
                    >
                        <Modal.Header closeButton>  {/* FIX 2: Always show close button */}
                            <Modal.Title style={{ fontSize: '20px', fontWeight: 'bold', color: "#465a64", }}>
                                {!editingId ? 'Add User Details' : 'Edit User Details'}
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3" controlId="formNewUser">
                                    <div className="d-flex align-items-center">
                                        <label
                                            htmlFor="formNewUser"
                                            className="form-label fw-semibold mb-0"
                                            style={{ display: "flex", alignItems: "center", gap: "4px" }}
                                        >
                                            {selectedTransmissionID === 1
                                                ? "Email Address"
                                                : selectedTransmissionID === 2
                                                    ? "Phone Number"
                                                    : "Contact"}
                                            {showInputAsterisk && (
                                                <span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                            )}
                                        </label>
                                    </div>

                                    <InputGroup>
                                        <div className="d-flex align-items-center gap-2" style={{ width: "100%", flexWrap: "nowrap" }}>
                                            {selectedTransmissionID === 2 ? (
                                                <PhoneInput
                                                    key={selectedCountry}
                                                    country={selectedCountry}
                                                    onlyCountries={allowedCountries}
                                                    value={newUserContact}
                                                    onChange={(phone, countryData) => {
                                                        if (countryData) {
                                                            setSelectedCountry(countryData.countryCode);
                                                            setSelectedDialCode(countryData.dialCode);
                                                        }
                                                        setNewUserContact(phone);
                                                        if (phone.trim() !== "") setShowInputAsterisk(false);
                                                    }}
                                                    inputStyle={{
                                                        width: '87%',
                                                        borderRadius: '6px',
                                                        height: '38px',
                                                        borderColor: '#ced4da',
                                                    }}
                                                    buttonStyle={{
                                                        borderColor: '#ced4da',
                                                    }}
                                                    dropdownStyle={{
                                                        zIndex: 9999,
                                                    }}
                                                    countryCodeEditable={false}
                                                    autoComplete="off"
                                                />
                                            ) : (
                                                <Form.Control
                                                    type="email"
                                                    value={newUserContact}
                                                    onChange={(e) => {
                                                        setNewUserContact(e.target.value.toLowerCase());
                                                        if (e.target.value.trim() !== "") setShowInputAsterisk(false);
                                                    }}
                                                    onKeyPress={handleKeyPress}
                                                    style={{
                                                        width: "87%",
                                                        borderRadius: "6px",
                                                        height: "38px",
                                                        borderColor: "#ced4da",
                                                        flexShrink: 0,
                                                    }}
                                                    maxLength={45}
                                                    autoComplete="no-password"
                                                />
                                            )}

                                            <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0, marginLeft: "8px" }}>
                                                {!editingId ? (
                                                    <Button
                                                        variant="outline-success"
                                                        onClick={handleAddToTempList}
                                                        title="Add"
                                                        style={{
                                                            backgroundColor: "#295a80",
                                                            borderColor: "#295a80",
                                                            color: "#fff",
                                                            minWidth: "38px",
                                                            height: "38px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            outline: "none",
                                                            boxShadow: "none",
                                                        }}
                                                        onFocus={(e) => e.target.blur()}
                                                    >
                                                        <FaPlus size={16} />
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <Button
                                                            onClick={handleAddToTempList}
                                                            title="Update"
                                                            style={{
                                                                backgroundColor: "#295a80",
                                                                borderColor: "#295a80",
                                                                color: "#fff",
                                                                minWidth: "38px",
                                                                height: "38px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <FaPencilAlt size={14} />
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </InputGroup>
                                </Form.Group>

                                {modalTempList.length > 0 && (
                                    <div className="table-responsive">
                                        <table className="tableClass">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '90px' }}>Sr. No.</th>
                                                    <th>
                                                        {selectedTransmissionID === 2
                                                            ? "Phone Number"
                                                            : "Email Address"}
                                                    </th>
                                                    <th style={{ width: '90px' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {modalTempList.map((item, idx) => (
                                                    <tr key={item.id}>
                                                        <td style={{ width: '90px' }}>{idx + 1}</td>
                                                        <td>{item.display}</td>
                                                        <td style={{ width: '90px' }}>
                                                            <div className="actbtn">
                                                                <img
                                                                    src={Icon3}
                                                                    title="Edit"
                                                                    alt="pencil"
                                                                    className="editicon"
                                                                    width={25}
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => handleEditTemp(item.id)}
                                                                />
                                                                {!editingId && (
                                                                    <FaTrash
                                                                        title="Delete"
                                                                        className="suspendicon"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => handleRemoveFromTemp(item.id)}
                                                                    />
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </Form>
                        </Modal.Body>

                        {/* FIX 3: Show SAVE button always */}
                        <Modal.Footer style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Button
                                variant="primary"
                                onClick={handleSaveFromModal}
                                style={{
                                    backgroundColor: "#325880",
                                    borderColor: "#325880",
                                    padding: "6px 24px",
                                    fontWeight: 600,
                                    letterSpacing: "0.5px",
                                }}
                            >
                                SAVE
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <div className="col-md-3 mb-3">
                        <div className="d-flex align-items-center justify-content-between">
                            {renderLabel('UserList', "Users List")}
                            <Button
                                type="button"
                                title="Add"
                                onClick={() => setShowModal(true)}
                                style={{
                                    backgroundColor: "#295a80",
                                    borderColor: "#295a80",
                                    color: "#fff",
                                    width: "26px",
                                    height: "25px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0",
                                    lineHeight: "1",
                                    borderRadius: "5px",
                                    outline: "none",
                                    boxShadow: "none",
                                    cursor: "pointer",
                                }}
                                onFocus={(e) => e.target.blur()}
                            >
                                <FaPlus size={12} />
                            </Button>
                        </div>
                        <strong style={{ display: 'none' }} id="tscp">*</strong>
                        <div
                            className="form-check border p-2 rounded"
                            style={{
                                marginTop: "0px",
                                minHeight: "38px",
                                maxHeight: "250px",
                                overflowY: "auto",
                                display: "flex",
                                flexDirection: "column",
                                paddingRight: "6px",
                            }}
                        >

                            {scpOptions.length === 0 ? (
                                <div className="text-center py-3 text-muted">
                                    No Users
                                </div>
                            ) : (
                                <>
                                    <div>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="select-all-users"
                                            checked={selectedUsers.length === scpOptions.length && scpOptions.length > 0}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedUsers(scpOptions.map((user) => user.value));
                                                } else {
                                                    setSelectedUsers([]);
                                                }
                                            }}
                                        />
                                        <label htmlFor="select-all-users" className="form-check-label fw-bold">
                                            Select All
                                        </label>
                                    </div>
                                    {scpOptions.map((user) => {
                                        const isTemplateUser = user.flag === 1;
                                        const isChecked = selectedUsers.includes(user.value);

                                        return (
                                            <div key={user.EMPTLD_ID || user.value} className="d-flex justify-content-between py-1" style={{ alignItems: "flex-start", gap: "6px" }}>
                                                <div className="d-flex" style={{ alignItems: "flex-start", flexGrow: 1 }}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        id={`user-${user.EMPTLD_ID || user.value}`}
                                                        value={user.value}
                                                        checked={isChecked}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;

                                                            if (isTemplateUser) {
                                                                console.log("Template user checkbox:", user.EMPTLD_ID, checked);

                                                                if (checked) {
                                                                    // Add to selected users
                                                                    setSelectedUsers(prev => [...prev, user.value]);

                                                                    // Update templateDetails - set EMPTLD_IsSelected to 1
                                                                    setTemplateDetails(prev =>
                                                                        prev.map(detail => {
                                                                            if (detail.EMPTLD_ID === user.EMPTLD_ID) {
                                                                                return {
                                                                                    ...detail,
                                                                                    isChecked: true,
                                                                                    EMPTLD_IsSelected: 1 // Changed to 1 when checked
                                                                                };
                                                                            }
                                                                            return detail;
                                                                        })
                                                                    );

                                                                    // Update scpOptions - set isChecked to true
                                                                    setScpOptions(prev =>
                                                                        prev.map(u =>
                                                                            u.EMPTLD_ID === user.EMPTLD_ID
                                                                                ? { ...u, isChecked: true, checked: true }
                                                                                : u
                                                                        )
                                                                    );
                                                                } else {
                                                                    // Remove from selected users
                                                                    setSelectedUsers(prev => prev.filter(id => id !== user.value));

                                                                    // Update templateDetails - set EMPTLD_IsSelected to 0
                                                                    setTemplateDetails(prev =>
                                                                        prev.map(detail => {
                                                                            if (detail.EMPTLD_ID === user.EMPTLD_ID) {
                                                                                return {
                                                                                    ...detail,
                                                                                    isChecked: false,
                                                                                    EMPTLD_IsSelected: 0 // Changed to 0 when unchecked
                                                                                };
                                                                            }
                                                                            return detail;
                                                                        })
                                                                    );

                                                                    // Update scpOptions - set isChecked to false
                                                                    setScpOptions(prev =>
                                                                        prev.map(u =>
                                                                            u.EMPTLD_ID === user.EMPTLD_ID
                                                                                ? { ...u, isChecked: false, checked: false }
                                                                                : u
                                                                        )
                                                                    );
                                                                }
                                                            } else {
                                                                // Regular user handling
                                                                handleSCPListChange(user.value);
                                                            }
                                                        }}
                                                        style={{ marginTop: "3px" }}
                                                    />
                                                    <label
                                                        //htmlFor={`user-${user.EMPTLD_ID || user.value}`}
                                                        className="form-check-label user-label mb-0"
                                                        style={{
                                                            fontSize: "0.9rem",
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            flexGrow: 1
                                                        }}
                                                    >
                                                        {user.label} ({selectedTransmissionID === 2 ? user.phone : user.email})
                                                    </label>
                                                </div>

                                                {isTemplateUser && (
                                                    <div className="d-flex align-items-center gap-1">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-secondary p-1 user-action-btn"
                                                            title="Edit"
                                                            onClick={() => handleEditUser(user)}
                                                            style={{
                                                                backgroundColor: "#295a80",
                                                                borderColor: "#295a80",
                                                                width: "26px",
                                                                height: "26px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "4px",
                                                            }}
                                                        >
                                                            <FaEdit size={13} color="#fff" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-danger p-1 user-action-btn"
                                                            title="Delete"
                                                            onClick={() => handleDeleteUser(user)}
                                                            style={{
                                                                width: "26px",
                                                                backgroundColor: "#295a80",
                                                                borderColor: "#295a80",
                                                                height: "26px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "4px",
                                                            }}
                                                        >
                                                            <FaTrash size={13} color="#fff" />
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </>
                            )}


                        </div>
                    </div>

                    {selectedTransmissionID !== 2 && (
                        <div className="col-md-3">
                            {renderLabel("selectedemailsubject", "Email Subject")}
                            <input
                                type="text"
                                value={selectedemailsubject}
                                onChange={handleEmailSubjectChange}
                                maxLength={1000}
                                className="form-input"
                                autoComplete="no-password"
                            />
                        </div>
                    )}

                    <div className="col-md-3">
                        <div>
                            <label className="">Status</label>
                        </div>
                        <div className='select-container'>
                            <Select
                                key={emailStatus}
                                name="emailStatus"
                                placeholder="--Select Status--"
                                options={emailStatusOptions.map(option => ({
                                    value: option.id,
                                    label: option.name
                                }))}
                                value={emailStatusOptions
                                    .map(option => ({ value: option.id, label: option.name }))
                                    .find(option => option.value === emailStatus)}
                                onChange={(selectedOption) => {
                                    if (selectedOption) {
                                        handleStatusChange({ target: { value: selectedOption.value } });
                                    }
                                }}
                                isDisabled={false}
                                isSearchable={false}
                                onMenuOpen={() => handleSelectOpen("EMTPL_Status")}
                                onMenuClose={handleSelectClose}
                                maxMenuHeight={150}
                            />
                            <div className="icon-container_list myList">
                                {isSelectOpen === "EMTPL_Status" ? (
                                    <IoCaretUpOutline />
                                ) : (
                                    <IoCaretDownOutline />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="field" style={{ marginLeft: "6px" }}>
                    {renderLabel(
                        "selectedemailbody",
                        selectedTransmissionID === 2 ? "Telegram Template" : "Email Template"
                    )}

                    {selectedTransmissionID === 2 ? (
                        <CKEditor
                            editor={ClassicEditor}
                            data={selectedemailbody}
                            config={telegramEditorConfiguration}
                            onReady={(editor) => {
                                const enterCommand = editor.commands.get('enter');
                                const shiftEnterCommand = editor.commands.get('shiftEnter');

                                editor.editing.view.document.on('enter', (evt, data) => {
                                    evt.stop();              // stop default Enter behavior
                                    editor.execute('shiftEnter');  // execute Shift+Enter instead
                                });
                            }}
                            onChange={handleEmailBodyChange}
                            className="emailTemplate"
                            style={{ color: "#465a64" }}
                        />
                    ) : selectedTransmissionID === 1 ? (
                        <CKEditor
                            editor={ClassicEditor}
                            data={selectedemailbody}
                            config={editorConfiguration}
                            // onReady={(editor) => {
                            //     // const enterCommand = editor.commands.get('enter');
                            //     // const shiftEnterCommand = editor.commands.get('shiftEnter');

                            //     // editor.editing.view.document.on('enter', (evt, data) => {
                            //     //     evt.stop();              // stop default Enter behavior
                            //     //     editor.execute('shiftEnter');  // execute Shift+Enter instead
                            //     // });

                            //     editor.editing.view.document.on('enter', (evt, data) => {
                            //         const model = editor.model;
                            //         const selection = model.document.selection;
                            //         const position = selection.getFirstPosition();
                            //         if (!position) return;

                            //         const block = position.parent;

                            //         const isInsideList =
                            //             block.hasAttribute('listType') ||
                            //             block.hasAttribute('listItemId');

                            //         if (!isInsideList) {
                            //             evt.stop();
                            //             editor.execute('shiftEnter');
                            //         }
                            //     });

                            // }}
                            onReady={(editor) => {

                                const model = editor.model;

                                // -------------------------
                                // 1️⃣ ENTER → shiftEnter (except list)
                                // -------------------------
                                editor.editing.view.document.on('enter', (evt, data) => {
                                    const selection = model.document.selection;
                                    const position = selection.getFirstPosition();
                                    if (!position) return;

                                    const block = position.parent;

                                    const isInsideList =
                                        block.hasAttribute('listType') ||
                                        block.hasAttribute('listItemId');

                                    if (!isInsideList) {
                                        evt.stop();
                                        editor.execute('shiftEnter');
                                    }
                                });


                                // -------------------------
                                // 2️⃣ Apply formatting to whole block if no selection
                                // -------------------------
                                const applyToWholeBlockIfNoSelection = (commandName) => {
                                    const command = editor.commands.get(commandName);

                                    if (!command) return;

                                    command.on('execute', () => {
                                        const selection = model.document.selection;

                                        if (selection.isCollapsed) {
                                            model.change(writer => {
                                                const position = selection.getFirstPosition();
                                                if (!position) return;

                                                const block = position.parent;

                                                // Select entire block
                                                writer.setSelection(block, 'in');
                                            });
                                        }
                                    });
                                };

                                // Apply to these toolbar options
                                applyToWholeBlockIfNoSelection('fontSize');
                                applyToWholeBlockIfNoSelection('fontFamily');
                                applyToWholeBlockIfNoSelection('bold');
                                applyToWholeBlockIfNoSelection('italic');
                                applyToWholeBlockIfNoSelection('underline');
                                applyToWholeBlockIfNoSelection('strikethrough');

                            }}
                            onChange={handleEmailBodyChange}
                            className="emailTemplate"
                            style={{ color: "#465a64" }}
                        />
                    ) : null}
                </div>

                <ToastContainer style={{
                    marginTop: '73px',
                    fontSize: '14px',
                    width: '40%',
                }} />
            </div>

            <div className="button-container">
                <button className="save_btn" onClick={handleSubmit}>SAVE</button>
                <button className="reset_btn" onClick={resetForm}>RESET</button>
                <Link to={`/EmailConfigurationList`} className="list_btn">LIST</Link>
            </div>
        </>
    )
}

export default EmailEdit;


